
import "../css/Footer.css";

function Footer() {
  return (
    <footer className="site-footer_container">
      {/* <hr className="site-footer_divider" /> */}

      <div className="site-footer_nav_list" >
        <nav>
          <ul>
            {/* TOOD: Mocking links for now to have no behavior (better than href="#" cuz no entry in History) */}
            <li><a href="/business/about-us">About Us</a></li>
            <li><a href="/content/coaching/contact/email">Contact</a></li>
            <li><a href="/business/terms-of-use">Terms of Use</a></li>
            <li><a href="/business/privacy-policy">Privacy Policy</a></li>
          </ul>
        </nav>
      </div>

      <div className="site-footer_copyright" >
        <p>&copy; 2024 Pivotal Wisdom. All rights reserved.</p>
      </div>
    </footer>
  );
}


export { Footer };
